export function LoadingSpinner() {
  return (
    <div
      data-testid="loading-spinner"
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        minHeight: '200px',
      }}
    >
      <div
        style={{
          width: 40,
          height: 40,
          border: '3px solid #e0e0e0',
          borderTopColor: '#6366f1',
          borderRadius: '50%',
          animation: 'spin 0.8s linear infinite',
        }}
      />
    </div>
  );
}
